<template>
  <div id="related-2">
    <BaseBanner v-bind="bannerProps" @onLoaded="completeInit" />

    <main class="content" :style="`background-image: url(${background.mainBg})`">
      <section class="content">
        <!-- Search section -->
        <div class="search-block show">
          <Search
            @search-query="searchRelated"
            :customPlaceholder="selectRelated.name"
          />
        </div>

        <!-- Related list section -->
        <div class="related-list">
          <RelatedList
            :list-data="relateds"
            :active-name="selectRelated.name"
            :icon="icon.witness"
            :active-icon="icon.witness_active"
            :not-found-icon="icon.witness_found"
            @change-related="changeRelated"
          />
        </div>

        <!-- Testimony section -->
        <TestimonySection
          v-if="found && selectRelated.testimonies"
          :select-related="selectRelated"
          :icon="icon"
          :had-found-exhibit-ids="hadFoundExhibitIds"
          :had-found-related-ids="hadFoundRelatedIds"
          :had-found-timeline-ids="hadFoundTimelineIds"
          :had-found-position-ids="hadFoundPositionIds"
          :tutorial-highlight-clue="tutorialHighlightClue"
          @change-judge="$emit('change-judge', $event)"
        />

        <!-- Not found message -->
        <div v-else class="not-found">
          此案件之證人尚待查詢中
        </div>
      </section>
    </main>

    <!-- Tutorial Overlay -->
    <TutorialOverlay
      v-if="tutorial.isActive.value"
      :current-step="tutorial.currentStep.value"
      :current-step-index="tutorial.currentStepIndex.value"
      :total-steps="tutorial.totalSteps.value"
      :target-rect="tutorial.targetRect.value"
      :is-first-step="tutorial.isFirstStep.value"
      :is-last-step="tutorial.isLastStep.value"
      @next="tutorial.nextStep"
      @prev="tutorial.prevStep"
      @go-to-step="tutorial.goToStep"
    />

    <!-- Wrong Page Popup -->
    <TutorialWrongPagePopup
      :show="tutorial.showWrongPagePopup.value"
      :page-name="tutorial.correctPageDisplayName.value"
      :target-component="tutorial.correctPageComponentName.value"
      @change-judge="handleChangeJudge"
    />
  </div>
</template>

<script>
import BaseBanner from '../../shared/baseBanner';
import Search from '../../shared/search.vue';
import RelatedList from './components/RelatedList.vue';
import TestimonySection from './components/TestimonySection.vue';
import { TutorialOverlay, TutorialWrongPagePopup } from '../../components/tutorial';
import { useRelateds } from '../../composables/useRelateds';

/**
 * Refactored Relateds page following SOLID principles
 * Single Responsibility: Orchestrates related page components and state
 * Open/Closed Principle: Extensible through composition and props
 * Dependency Inversion: Depends on composables and child components
 */
export default {
  name: 'RelatedPage',

  components: {
    BaseBanner,
    Search,
    RelatedList,
    TestimonySection,
    TutorialOverlay,
    TutorialWrongPagePopup
  },
  
  props: [
    'memberLineId', 
    'memberName', 
    'groupId', 
    'updateGroupStoryShip', 
    'updateFinishedDemo'
  ],
  
  emits: ['change-judge'],

  setup(props, { emit }) {
    // Use the relateds composable for all business logic
    const relatedsState = useRelateds(props);

    const handleChangeJudge = (componentName) => {
      emit('change-judge', componentName);
    };

    // Return all the reactive state and methods
    return {
      ...relatedsState,
      handleChangeJudge
    };
  }
};
</script>

<style lang="scss" scoped>
@import './style.scss';

.related-page {
  .search-block {
    margin-bottom: 1rem;
    position: relative;
  }

  .related-list {
    position: relative;
    margin-bottom: 1rem;
  }

  .not-found {
    text-align: center;
    padding: 2rem;
    font-size: 1.2rem;
    color: #666;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 8px;
    margin: 1rem;
  }
}

// Responsive design
@media (max-width: 768px) {
  .related-page {
    .search-block,
    .related-list {
      margin: 0.5rem;
    }
  }
}
</style>